var map = {
	"./consumption_blue.png": "6c48",
	"./consumption_classic.png": "0d6f",
	"./consumption_disable.png": "9bf1",
	"./consumption_green.png": "a194b",
	"./consumption_orange.png": "129f",
	"./consumption_purple.png": "5811"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65df";